import useAuthStore, {subscribeAuth} from "app/Service/Auth/AuthService"
import SystemModuleNavigation from "app/WebController/Component/Nav/SystemModuleNavigation"
import AuthLanguageSelect from "app/WebController/Header/AuthLanguageSelect"
import Avatar from "app/WebController/Header/Avatar"
import ThemeModeSelector from "app/WebController/Header/ThemeModeSelector"
import Logger from "logger/logger"
import React, {CSSProperties, useEffect} from "react"
import {Link} from "react-router-dom"
import LogoSvg from "static/img/logo.svg"

const HeaderController = () => {

  const {isAuthenticated} = useAuthStore([
    subscribeAuth.isAuthenticated
  ], 'HeaderController')

  useEffect(() => {
    Logger('Element.Header.init')

    return () => {
      Logger('Element.Header.unloading')
    }
  }, [])

  const Wrapper: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  }

  const Logo: CSSProperties = {
    order: 0
  }

  const ActionButtons: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    order: 1
  }

  return (
    <div style={Wrapper} className={`header`} id={'header'}>
      <Link to={`/`} className={`logo`} style={Logo}>
        <LogoSvg/>
      </Link>
      <div style={ActionButtons}>
        <ThemeModeSelector/>
        {isAuthenticated && (
          <Avatar/>
        )}
        <AuthLanguageSelect/>
      </div>
      {isAuthenticated && (
        <SystemModuleNavigation/>
      )}
    </div>
  )
}

export default HeaderController
